module.exports = new __parcel__URL__("urban-1.b13734e6.jpeg").toString();